import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import { useTimer } from "../../hooks/useTimer";
import { tutorialsSlice } from "./tutorialsReducer";
import { locationSlice } from "../Location/locationReducer";
import { LOCATION_NAMES } from "../Location/locationConstants";
import { logAppsflyerAction } from "../../app/appActions";
import { LOG_AF_EVENT_NAMES } from "../../app/appConstants";
import { userHintsSlice } from "../UserHints/userHintsReducer";
import { getDemoLimitsUserHintSeenSelector } from "../UserHints/userHintsSelectors";
import { getIsDemoLimitsAvailableSelector } from "../DemoLimits/demoLimitsSelectors";
import { IBeginnersGuideInviteProps } from "../Academy/BeginnersGuideInvite/beginnersGuideInvite.t";

const DELAY_TO_SHOW_GUIDE_MS = 3000;

interface IUseTutorialsBeginnersGuideInviteProps {
    isAllowShow: boolean;
}

function useTutorialsBeginnersGuideInvite(props: IUseTutorialsBeginnersGuideInviteProps): IBeginnersGuideInviteProps {
    const { isAllowShow } = props;
    const dispatch = useDispatch();
    const [isVisible, setIsVisible] = useState(false);
    const isDemoLimitsUserHintSeen = useSelector(getDemoLimitsUserHintSeenSelector);
    const isDemoLimitsAvailable = useSelector(getIsDemoLimitsAvailableSelector);

    const showGuideHandler = useCallback(() => {
        setIsVisible(true);
    }, []);

    const { startTimer: startTimerToShowGuide, stopTimer: stopTimerToShowGuide } = useTimer(showGuideHandler);

    useEffect(() => {
        if (isAllowShow) {
            startTimerToShowGuide(DELAY_TO_SHOW_GUIDE_MS);
        } else {
            setIsVisible(false);
            stopTimerToShowGuide();
        }
    }, [isAllowShow, startTimerToShowGuide, stopTimerToShowGuide]);

    const onButtonOpenClickHandler = useCallback(() => {
        dispatch(tutorialsSlice.actions.setIsShowBeginnersGuideInviteAction(false));
        dispatch(locationSlice.actions.openLocationAction({ name: LOCATION_NAMES.BEGINNERS_GUIDE }));
        dispatch(logAppsflyerAction({
            name: LOG_AF_EVENT_NAMES.MINI_ONBOARDING_INVITATION,
            payload: { type: 'lets_do_it' },
        }));
    }, [dispatch]);

    const onButtonCloseClickHandler = useCallback(() => {
        dispatch(tutorialsSlice.actions.setIsShowBeginnersGuideInviteAction(false));
        dispatch(logAppsflyerAction({
            name: LOG_AF_EVENT_NAMES.MINI_ONBOARDING_INVITATION,
            payload: { type: 'not_now' },
        }));
        if (!isDemoLimitsUserHintSeen && isDemoLimitsAvailable) {
            dispatch(userHintsSlice.actions.setDemoLimitsHintShownAction(true));
        }
    }, [dispatch, isDemoLimitsUserHintSeen, isDemoLimitsAvailable]);

    return {
        isVisible,
        onButtonOpenClickHandler,
        onButtonCloseClickHandler,
    }
}

export default useTutorialsBeginnersGuideInvite;
